<template>
  <div class="white main">
    <div
      v-if="chatMessageEdit && !chatMessageEdit?.attachments?.length"
      class="chat__edit d-grid gap-4 py-2 px-6"
      @click="onScrollToEditMessage"
    >
      <div class="chat__edit__main d-grid align-center">
        <BaseIcon class="chat__edit__icon" icon="chat-edit" color="#277FAF" />
        <div class="chat__edit__text">
          <div class="chat__edit__text__title f14 primary--text">Редактирование</div>
          {{ chatMessageEdit.content }}
        </div>
      </div>
      <button class="pa-1 chat__edit__cross" @click="offEditMessage">
        <BaseIcon class="chat__edit__icon" icon="button-cross" color="#EB5757" />
      </button>
    </div>
    <form
      class="chat__input d-grid"
      :class="recording || (!recording && recordFile) ? 'grid-col-1-max' : 'grid-col-max-1-max'"
    >
      <template v-if="!recording && !recordFile">
        <ChatFilesUploadModal
          :textSend="textSend"
          :onCreateMessage="onCreateMessage"
          @filesUploadModalOpen="onFilesUploadModalOpen"
          @filesUploadModalClose="onFilesUploadModalClose"
          :chatTranslations="chatTranslations"
          ref="ChatFilesUploadModal"
        />
        <BaseInput
          :placeholder="chatTranslations.write_message + '...'"
          v-model="textSend"
          type="textarea"
          no-resize
          :rows="textSend !== null && textSend.indexOf('\n') > -1 ? 2 : 1"
          @keydown.enter.exact.prevent="() => onCreateMessage(textSend)"
          @keydown.enter.shift.exact.prevent="textSend += '\n'"
          @paste="PASTE_chatFileSelect"
          @input="onInput"
        />
      </template>
      <div v-else-if="recording" class="px-6 py-4 d-flex gap-4 align-center">
        <v-icon color="red">mdi-record</v-icon>
        <div class="f16">{{ $convertMillisToMinutesAndSeconds(mediaRecorderTimer) }}</div>
      </div>
      <div v-else-if="!recording && recordFile" class="px-6 py-4 d-flex gap-4 align-center">
        <button class="pa-2" @click="DEFAULT_recordData">
          <v-icon color="red"> mdi-delete </v-icon>
        </button>
        <AudioPlayer v-if="recordType === 'audio'" :src="$getFileUrl(recordFile)" />
      </div>
      <div class="d-flex">
        <button
          v-if="textSend !== '' || (!recording && recordFile)"
          class="chat__input__send py-4 px-6"
          @click="() => onCreateMessage(textSend, recordFile ? [recordFile] : null)"
          type="button"
        >
          <BaseIcon icon="chat-send" color="#277FAF" />
        </button>
        <div class="my-2 mx-6 d-flex gap-2" v-else>
          <BaseRecord v-show="!recordType || recordType === 'audio'" />
          <BaseRecord v-show="!recordType || recordType === 'video'" isVideo />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import ChatFilesUploadModal from 'components/chat/files/ChatFilesUploadModal'
import AudioPlayer from 'components/base/file/AudioPlayer'
import SocketioChatService from '~/services/socketio/socketio.chat.service.js'
import _ from 'lodash'

export default {
  name: 'ChatInputField',
  components: { ChatFilesUploadModal, AudioPlayer },
  props: {
    chatItem: Object,
  },
  data() {
    return {
      textSend: '',
    }
  },
  computed: {
    ...mapState(['chatApiDomain']),
    ...mapGetters(['apiDomain']),
    ...mapGetters('user', ['userData']),
    ...mapState('record', [
      'mediaRecorderStatus',
      'mediaRecorderTimer',
      'maxRecordingTime',
      'recordFile',
      'recordType',
    ]),
    ...mapState('chat/messages', ['chatMessageEdit']),
    recording() {
      return this.mediaRecorderStatus === 'recording'
    },
    recordingVideo() {
      return this.recording && this.recordType === 'video'
    },
    chatTranslations() {
      return (
        this.localStorage.translations.pages.chat && this.localStorage.translations.pages.chat.all
      )
    },
  },
  watch: {
    '$route.params.id'() {
      this.offEditMessage()
    },
    chatMessageEdit() {
      this.onEditMessage(this.chatMessageEdit)
    },
  },
  methods: {
    ...mapActions('chat', ['CREATE_chatPersonal']),
    ...mapActions('chat/file', ['PASTE_chatFileSelect']),
    ...mapActions('record', ['DEFAULT_recordData']),
    ...mapActions('chat/messages', [
      'UPDATE_chatMessage',
      'CANCEL_chatMessageEdit',
      'GET_chatAdditionalMessageById',
    ]),
    ...mapMutations('chat/messages', ['SET_pushMessage']),
    async onCreateMessage(text, files) {
      return new Promise((resolve, reject) => {
        // console.log('onCreateMessage', { text, files })
        const createOrUpdateMessage = async (chatId) => {
          const chatId_unseen = Number(this?.chatItem?._count?.messages)
          const chatId_lastMessage = Math.max(...this.chatItem.messages.map((i) => i.id))
          const chatId_send = chatId ? chatId : this.$route.params.id
          let content = text === '' ? null : text
          if (this.chatMessageEdit) {
            let data = {
              content,
            }
            data.id = this.chatMessageEdit.id
            if (content !== this.chatMessageEdit.content) {
              this.UPDATE_chatMessage({
                data,
                // chatId: chatId_send,
              }).then(() => {
                resolve(true)
                this.textSend = ''
              })
            }
          } else {
            const messages = this.chatItem.messages
            let data = {
              chat: {
                id: chatId_send,
              },
              message: {
                attachments: null,
                chatId: chatId_send,
                content,
                id: new Date().toISOString(),
                isSeen: false,
                senderId: this.userData.id,
                sentAt: new Date().toISOString(),
                updatedAt: null,
                status: 'waiting',
                // status: 'error',
              },
              previousMessage: messages.length ? messages[messages.length - 1] : null,
            }
            if (files && files.length) {
              data.message.attachments = files
            }
            if (chatId_unseen > 0) {
              this.GET_chatAdditionalMessageById({
                chatId: chatId_send,
                lastMessageId: chatId_lastMessage,
                order: 'asc',
                take: chatId_unseen,
              }).then((res) => {
                data.previousMessage = res.length ? res[res.length - 1] : null
                this.SET_pushMessage(data)
              })
            } else await this.SET_pushMessage(data)
            this.textSend = ''
          }
        }
        this.DEFAULT_recordData()
        if ((text !== null && text !== '') || (files && files.length)) {
          if (this.$route.params.id.match(/personal_/)) {
            const userId = this.$route.params.id.split('_')[1]
            this.CREATE_chatPersonal({ data: { peerId: Number(userId) } }).then((resp) => {
              this.$nextTick(async function () {
                await this.$router.replace({ name: 'chatById', params: { id: resp.id } })
                createOrUpdateMessage(resp.id)
              })
            })
          } else {
            createOrUpdateMessage()
          }
        }
      })
    },
    onScrollToEditMessage() {
      this.$nextTick(function () {
        const target = document.getElementById('message_' + this.chatMessageEdit.id)
        this.$scrollToElementById({
          target,
        })
        const removeClassHighlighting = () => target.classList.remove('highlighting')
        removeClassHighlighting()
        target.classList.add('highlighting')
        setTimeout(removeClassHighlighting, 2000)
      })
    },
    onEditMessage(message) {
      if (message) {
        if (message.attachments.length) {
          this.textSend = ''
        } else {
          this.textSend = message?.content || ''
        }
      }
    },
    offEditMessage() {
      this.CANCEL_chatMessageEdit()
      this.textSend = ''
    },
    onFilesUploadModalOpen() {
      this.textSend = ''
    },
    onFilesUploadModalClose(value) {
      // console.log('onFilesUploadModalClose', value)
      this.textSend = value
    },
    onInput(v) {
      this.debounced()
    },
    debounced: _.debounce(
      function () {
        SocketioChatService.userStartTyping()
      },
      300,
      { maxWait: 2100 },
    ),
  },
}
</script>

<style lang="scss" scoped>
.main {
  min-height: 60px;
}
.chat {
  &__edit {
    grid-template-columns: 1fr 30px;
    border-bottom: 1px solid #e0e0e0;
    &__main {
      grid-template-columns: 30px 1fr;
      gap: inherit;
      cursor: pointer;
      user-select: none;
    }
    &__icon:deep() {
      svg {
        width: 100%;
        height: auto;
      }
    }
    &__text {
      white-space: nowrap; /* Запрещаем перенос строк */
      overflow: hidden; /* Обрезаем все, что не помещается в область */
      text-overflow: ellipsis;
    }
  }
  &__input {
    border-radius: 0px 0px 10px 10px;
    &__send {
      line-height: 1;
    }
    :deep() .v-input .v-input__slot:not(.v-textarea) fieldset {
      color: #c8c8c8 !important;
      border: 1px solid transparent !important;
    }
  }
}
</style>
